import Drawer from 'common/drawer';
import { useQueryGetProjectsFromJanus } from 'hooks/queries';
import _ from 'lodash';
import { useParsedQueryString, useUpdatedTo } from 'projects/project-selector/hooks';
import { useHistory } from 'react-router-dom';
import { useIsImportProjectsDrawerOpen } from 'projects/project-selector/project-importer-drawer';
import { ProjectDetails } from './project-details';

export const routeParamsToCloseProjectDetailsDrawer = _.constant({ project: undefined });
export const routeParamsToOpenProjectDetailsDrawer = (project) => ({ project: project?.id || project?.projectId || project });

export const useIsProjectDetailsDrawerOpen = () => (
  _.every([!useIsImportProjectsDrawerOpen(), !!useParsedQueryString()?.project])
);

export const ProjectDetailsDrawer = (detailsProps) => {
  const history = useHistory();
  const isProjectDrawerOpen = useIsProjectDetailsDrawerOpen();
  const projectsQuery = useQueryGetProjectsFromJanus();
  const toClosedDrawer = useUpdatedTo(routeParamsToCloseProjectDetailsDrawer());
  const close = () => history.replace(toClosedDrawer);

  return (
    <Drawer title="Project Details" backdrop={false} loading={!projectsQuery.isSuccess} handleClick={close} show={isProjectDrawerOpen}>
      <ProjectDetails {...detailsProps} />
    </Drawer>
  );
};
